import React from "react";

const MainHeader = ({ icon, header }) => {
    return (
        <>
            <header className="main-model-form-header main-content-header flex items-center">
                {icon}
                <h2 className="h2">{header}</h2>
            </header>
        </>
    );
};

export default MainHeader;
